@if(productForm) {
<form [formGroup]="productForm">

      <!-- ── Main ─────────────────────────────────────────────────────────── -->
      <div class="col-md-12 section-group">
        <h6 class="section-title">Main</h6>
        <div class="row">
          @if (productNameControl) {
          <mat-form-field [class]="commonNameControl ? 'col-md-6' : 'col-md-12'">
            <mat-label>Product name</mat-label>
            <input matInput placeholder="Product Name" [formControl]="productNameControl" required />
            <!-- The uploaded image filename is built from this name, and these
                 characters end or redirect a URL path, so the image link breaks. -->
            <mat-hint>Avoid # ? % / \ &mdash; these characters break the product image link.</mat-hint>
            @if (productNameControl.hasError('contactInfo')) {
            <mat-error>{{ productNameControl.getError('contactInfo') }}</mat-error>
            } @else if (productNameControl.invalid && (productNameControl.dirty || productNameControl.touched)) {
            <mat-error>Product name is required</mat-error>
            }
          </mat-form-field>
          } @if (commonNameControl) {
          <!-- Optional. When filled, storefront product cards show
               "<common name> (<product name>)". -->
          <mat-form-field class="col-md-6">
            <mat-label>Common name (optional)</mat-label>
            <input matInput placeholder="e.g. Black Arrow Tetra" [formControl]="commonNameControl" />
            <mat-hint>Shown before the product name: "Common name (Product name)".</mat-hint>
          </mat-form-field>
          }

          @if (qtyControl) {
          <mat-form-field class="col-md-4">
            <mat-label>Quantity</mat-label>
            <input matInput placeholder="Quantity" [formControl]="qtyControl" type="number" required />
            @if (qtyControl.invalid && (qtyControl.dirty || qtyControl.touched)) {
            <mat-error>Quantity is required</mat-error>
            }
          </mat-form-field>
          }

          @if (categoryIdControl) {
          <div class="col-md-4">
            <fh-form-autocomplete
              [options]="categoryOptions()"
              label="Category"
              [formControl]="categoryIdControl"
              [required]="true"
              (change)="onCategorySelectionChange($any($event))"
            />
          </div>
          }

          @if (subcategoryIdControl) {
          <div class="col-md-4">
            <fh-form-autocomplete
              [options]="subCategoryOptions()"
              label="Sub-Category"
              [formControl]="subcategoryIdControl"
              [required]="true"
              (change)="onSubcategorySelectionChange($any($event))"
            />
          </div>
          }

          @if (subsubcategoryIdControl) {
          <div class="col-md-4">
            <fh-form-autocomplete
              [options]="subSubCategoryOptions()"
              label="Sub Sub-Category"
              [formControl]="subsubcategoryIdControl"
            />
          </div>
          }

          @if (moreDescriptionControl) {
          <div class="col-md-12 mt-2">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <strong>Product Description</strong>
              @if (minSizeControl) {
              <button
                type="button"
                mat-stroked-button
                color="primary"
                [disabled]="isGeneratingDescription()"
                (click)="generateDescription()"
                style="font-size: 0.8rem; height: 32px; line-height: 32px;"
              >
                @if (isGeneratingDescription()) {
                <mat-spinner diameter="16" style="display:inline-block; vertical-align:middle; margin-right:6px;"></mat-spinner>
                Generating...
                } @else {
                ✨ Generate with AI
                }
              </button>
              }
            </div>
            <angular-editor
              [formControl]="moreDescriptionControl"
              [placeholder]="'More Description*'"
              [config]="editorConfig"
            ></angular-editor>
            <!-- Shown straight away (not only once touched): an existing product
                 that already has contact details cannot be saved until they go. -->
            @if (moreDescriptionControl.hasError('contactInfo')) {
            <mat-error>{{ moreDescriptionControl.getError('contactInfo') }}</mat-error>
            } @else if (moreDescriptionControl.invalid && (moreDescriptionControl.dirty || moreDescriptionControl.touched)) {
            <mat-error>More Description is required</mat-error>
            }
            <br />
          </div>
          }
        </div>
      </div>

      <!-- ── Product Attributes (livestock only) ───────────────────────── -->
      @if (minSizeControl || maxSizeControl || temperamentControl || waterConditionControl || wysiwygControl) {
      <div class="col-md-12 section-group">
        <h6 class="section-title">Product Attributes</h6>
        <div class="row">
          @if (minSizeControl) {
          <mat-form-field class="col-md-12">
            <mat-label>Minimum Size</mat-label>
            <input matInput placeholder="In cms" [formControl]="minSizeControl" type="number" />
            @if (minSizeControl.invalid && (minSizeControl.dirty || minSizeControl.touched)) {
            <mat-error>Minimum Size is required</mat-error>
            }
          </mat-form-field>
          }

          @if (maxSizeControl) {
          <mat-form-field class="col-md-12">
            <mat-label>Maximum Size</mat-label>
            <input matInput placeholder="In cms" [formControl]="maxSizeControl" type="number" />
            @if (maxSizeControl.invalid && (maxSizeControl.dirty || maxSizeControl.touched)) {
            <mat-error>Maximum Size is required</mat-error>
            }
          </mat-form-field>
          }

          @if (temperamentControl) {
          <div class="col-md-12">
            <fh-form-autocomplete
              [options]="temperamentOptions()"
              label="Temperament"
              [formControl]="temperamentControl"
            />
          </div>
          }

          @if (waterConditionControl) {
          <div class="col-md-12">
            <fh-form-autocomplete
              [options]="waterConditionOptions"
              label="Water Condition"
              [formControl]="waterConditionControl"
            />
          </div>
          }

          @if (wysiwygControl) {
          <mat-form-field class="col-md-12">
            <mat-label>WYSIWYG</mat-label>
            <mat-select [formControl]="wysiwygControl">
              @for (opt of wysiwygOptions; track opt.value) {
              <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }
        </div>
      </div>
      }

      <!-- ── Others ────────────────────────────────────────────────────── -->
      @if (isPromotedControl || isRareFishControl || isPreOrderControl || isRequestQuoteControl || productExpiryControl || statusControl) {
      <div class="col-md-12 section-group">
        <h6 class="section-title">Others</h6>
        <div class="row">
          @if (isPromotedControl) {
          <div class="col-md-4">
            <fh-form-autocomplete
              [options]="booleanOptions()"
              label="Promoted"
              [formControl]="isPromotedControl"
            />
          </div>
          }

          @if (isRareFishControl) {
          <div class="col-md-4">
            <fh-form-autocomplete
              [options]="booleanOptions()"
              label="Is Rare"
              [formControl]="isRareFishControl"
            />
          </div>
          }

          @if (isPreOrderControl) {
          <div class="col-md-4">
            <fh-form-autocomplete
              [options]="booleanOptions()"
              label="Is Pre-Order"
              [formControl]="isPreOrderControl"
            />
          </div>
          }

          @if (isRequestQuoteControl) {
          <div class="col-md-4">
            <fh-form-autocomplete
              [options]="booleanOptions()"
              label="Request Quote"
              [formControl]="isRequestQuoteControl"
            />
            @if (isRequestQuoteControl.value) {
              <mat-hint class="text-xs text-amber-600">Price fields will be set to Not Applicable</mat-hint>
            }
          </div>
          }

          @if (productExpiryControl) {
          <mat-form-field class="col-md-4">
            <mat-label>Expiry Date</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [formControl]="productExpiryControl"
              [min]="minDate"
              [max]="maxDate"
            />
            <mat-hint>{{ productExpiryHintText }}</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          }

          @if (statusControl) {
          <div class="col-md-4">
            <fh-form-autocomplete
              [options]="statusOptions()"
              label="Visibility"
              [formControl]="statusControl"
            />
          </div>
          }
        </div>
      </div>
      }

      <!-- ── Tank Dimensions ───────────────────────────────────────────── -->
      @if (tankBreadthControl || tankHeightControl || tankLengthControl || capacityControl) {
      <div class="col-md-12 section-group">
        <h6 class="section-title">Tank Dimensions</h6>
        <div class="row">
          @if (tankBreadthControl) {
          <mat-form-field class="col-md-4">
            <mat-label>Breadth in cms</mat-label>
            <input matInput placeholder="Breadth" [formControl]="tankBreadthControl" type="number" required />
            @if (tankBreadthControl.invalid && (tankBreadthControl.dirty || tankBreadthControl.touched)) {
            <mat-error>Breadth is required</mat-error>
            }
          </mat-form-field>
          }

          @if (tankHeightControl) {
          <mat-form-field class="col-md-4">
            <mat-label>Height in cms</mat-label>
            <input matInput placeholder="Height" [formControl]="tankHeightControl" type="number" required />
            @if (tankHeightControl.invalid && (tankHeightControl.dirty || tankHeightControl.touched)) {
            <mat-error>Height is required</mat-error>
            }
          </mat-form-field>
          }

          @if (tankLengthControl) {
          <mat-form-field class="col-md-4">
            <mat-label>Length in cms</mat-label>
            <input matInput placeholder="Length" [formControl]="tankLengthControl" type="number" required />
            @if (tankLengthControl.invalid && (tankLengthControl.dirty || tankLengthControl.touched)) {
            <mat-error>Length is required</mat-error>
            }
          </mat-form-field>
          }

          @if (capacityControl) {
          <mat-form-field class="col-md-4">
            <mat-label>Capacity in gallons</mat-label>
            <input matInput placeholder="Capacity" [formControl]="capacityControl" type="number" required />
            @if (capacityControl.invalid && (capacityControl.dirty || capacityControl.touched)) {
            <mat-error>Capacity for tank is required</mat-error>
            }
          </mat-form-field>
          }
        </div>
      </div>
      }

      <!-- ── Media ─────────────────────────────────────────────────────── -->
      @if (mediaPickerControl) {
      <div class="col-md-12 section-group">
        <h6 class="section-title">Media</h6>
        <fh-media-picker [formControl]="mediaPickerControl"></fh-media-picker>
      </div>
      }

</form>
}

<!-- ── Country-Specific Pricing & Delivery ──────────────────────────── -->
<div class="col-md-12 country-specific-section mt-4">
      <mat-accordion class="country-sections" [formGroup]="countrySpecificForm" multi>

        <!-- Selected / active destinations -->
        @if (getSelectedCountries().length > 0) {
        <div class="destination-group">
          <h4 class="section-title">Country Specific Pricing, Delivery &amp; Variations</h4>
          @for (country of getSelectedCountries(); track country.iso2) {
          <mat-expansion-panel
            [expanded]="isCountryExpanded(country.iso2)"
            (opened)="onPanelOpened(country.iso2)"
            (closed)="onPanelClosed(country.iso2)"
            class="mb-2"
          >
            <mat-expansion-panel-header class="py-2">
              <mat-panel-title class="country-panel-title">
                <div class="flex items-center justify-between w-full">
                  <div class="flex items-center gap-2">
                    <mat-checkbox
                      [checked]="isCountrySelected(country.iso2)"
                      (change)="onDestinationCountryChange($event, country.iso2)"
                      (click)="$event.stopPropagation()"
                      color="primary"
                    >
                      {{ country.name }} ({{ country.currency }})
                    </mat-checkbox>
                    @if (isMarketRestricted(country.iso2)) {
                    <span class="text-sm text-gray-500">{{ marketBlockText(country.iso2) }} - untick to save</span>
                    }
                  </div>
                  @if (isCountrySelected(country.iso2) && isCountryFormInvalid(country.iso2)) {
                  <div class="validation-hint">
                    <mat-icon class="error-icon">warning</mat-icon>
                    <span class="error-text">Needs info</span>
                  </div>
                  }
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            @if (isCountrySelected(country.iso2)) {
            <div class="country-section py-3" [formGroupName]="country.iso2">
              <div class="row">
                <mat-form-field appearance="outline" class="col-md-12">
                  <mat-label>Display Price</mat-label>
                  <input matInput formControlName="displayPrice" type="number"
                    [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                  @if (isRequestQuoteControl?.value) {
                    <mat-hint class="text-amber-600">Not Applicable</mat-hint>
                  }
                  @if (shouldShowError(countrySpecificForm.get(country.iso2)?.get('displayPrice') ?? null)) {
                  <mat-error>{{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get('displayPrice') ?? null) }}</mat-error>
                  }
                </mat-form-field>

                <!-- Delivery charge and the walk-in switch sit together: ticking it
                     zeroes and disables the charge, so they read as one control
                     rather than two that happen to be near each other. -->
                <div class="col-md-12 d-flex align-items-start gap-3">
                  <div class="flex-grow-1 min-w-0">
                <!-- Only for Merchant Self Delivery: with FishyHub Delivery
                     (admin portal > vendor > Delivery) FishyHub sets the charge. -->
                @if (showsDeliveryCharge(country.iso2)) {
                @if (deliveryZonesFor(country.iso2).length > 0) {
                <!-- US / MY: charged by the customer's shipping-address state, per zone. -->
                <div class="col-md-12 d-flex flex-column gap-1 mb-2">
                  <span class="text-sm font-medium">Delivery Charge by {{ country.iso2 }} zone</span>
                  @for (z of deliveryZonesFor(country.iso2); track z.zone) {
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ z.label }}</mat-label>
                    <input matInput [formControlName]="zoneControlName(z.zone)" type="number"
                      [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                    <mat-hint>{{ isRequestQuoteControl?.value ? 'Not Applicable' : z.states }}</mat-hint>
                    @if (shouldShowError(countrySpecificForm.get(country.iso2)?.get(zoneControlName(z.zone)) ?? null)) {
                    <mat-error>{{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get(zoneControlName(z.zone)) ?? null) }}</mat-error>
                    }
                  </mat-form-field>
                  }
                </div>
                } @else {
                <mat-form-field appearance="outline" class="col-md-12">
                  <mat-label>Delivery Charge</mat-label>
                  <input matInput formControlName="deliveryCharge" type="number"
                    [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                  @if (isRequestQuoteControl?.value) {
                    <mat-hint class="text-amber-600">Not Applicable</mat-hint>
                  }
                  @if (shouldShowError(countrySpecificForm.get(country.iso2)?.get('deliveryCharge') ?? null)) {
                  <mat-error>{{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get('deliveryCharge') ?? null) }}</mat-error>
                  }
                </mat-form-field>
                }
                }
                  </div>
                  <mat-checkbox formControlName="walkInOnly" class="mt-3 flex-shrink-0">
                    Walk in Only
                  </mat-checkbox>
                </div>

              </div>

              <div class="mt-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span class="text-sm font-medium">Product Variations</span>
                  <span class="text-muted" style="font-size: 0.75rem;">(At least one required)</span>
                </div>
                <div class="product-options">
                  <fh-product-options
                    [formControl]="getCountryControl(country.iso2, 'productOptions')"
                    [isRequestQuote]="isRequestQuoteControl?.value ?? false"
                    [sameCountry]="isSupplierCountry(country.iso2)"
                  ></fh-product-options>
                </div>
              </div>
            </div>
            }
          </mat-expansion-panel>
          }
        </div>
        }

        <!-- Available destinations to add -->
        @if (getUnselectedCountries().length > 0) {
        <div class="destination-group">
          <h4 class="section-title">Select Destination Countries to enter variation pricing and delivery</h4>
          @for (country of getUnselectedCountries(); track country.iso2) {
          <mat-expansion-panel
            [disabled]="marketBlocked(country.iso2)"
            [expanded]="isCountryExpanded(country.iso2)"
            (opened)="onPanelOpened(country.iso2)"
            (closed)="onPanelClosed(country.iso2)"
            class="mb-2"
          >
            <mat-expansion-panel-header class="py-2">
              <mat-panel-title class="country-panel-title">
                <!-- Greyed out: not enabled for this store, or a cross-border restriction. -->
                <div class="flex flex-wrap items-center gap-x-3">
                  <mat-checkbox
                    [checked]="isCountrySelected(country.iso2)"
                    [disabled]="marketBlocked(country.iso2)"
                    (change)="onDestinationCountryChange($event, country.iso2)"
                    (click)="$event.stopPropagation()"
                    color="primary"
                  >
                    {{ country.name }} ({{ country.currency }})
                  </mat-checkbox>
                  @if (marketBlocked(country.iso2)) {
                  <span class="text-sm text-gray-500">{{ marketBlockText(country.iso2) }}</span>
                  }
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            @if (isCountrySelected(country.iso2)) {
            <div class="country-section py-3" [formGroupName]="country.iso2">
              <div class="row">
                <mat-form-field appearance="outline" class="col-md-12">
                  <mat-label>Display Price</mat-label>
                  <input matInput formControlName="displayPrice" type="number"
                    [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                  @if (isRequestQuoteControl?.value) {
                    <mat-hint class="text-amber-600">Not Applicable</mat-hint>
                  }
                  @if (shouldShowError(countrySpecificForm.get(country.iso2)?.get('displayPrice') ?? null)) {
                  <mat-error>{{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get('displayPrice') ?? null) }}</mat-error>
                  }
                </mat-form-field>

                <!-- Delivery charge and the walk-in switch sit together: ticking it
                     zeroes and disables the charge, so they read as one control
                     rather than two that happen to be near each other. -->
                <div class="col-md-12 d-flex align-items-start gap-3">
                  <div class="flex-grow-1 min-w-0">
                <!-- Only for Merchant Self Delivery: with FishyHub Delivery
                     (admin portal > vendor > Delivery) FishyHub sets the charge. -->
                @if (showsDeliveryCharge(country.iso2)) {
                @if (deliveryZonesFor(country.iso2).length > 0) {
                <!-- US / MY: charged by the customer's shipping-address state, per zone. -->
                <div class="col-md-12 d-flex flex-column gap-1 mb-2">
                  <span class="text-sm font-medium">Delivery Charge by {{ country.iso2 }} zone</span>
                  @for (z of deliveryZonesFor(country.iso2); track z.zone) {
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ z.label }}</mat-label>
                    <input matInput [formControlName]="zoneControlName(z.zone)" type="number"
                      [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                    <mat-hint>{{ isRequestQuoteControl?.value ? 'Not Applicable' : z.states }}</mat-hint>
                    @if (shouldShowError(countrySpecificForm.get(country.iso2)?.get(zoneControlName(z.zone)) ?? null)) {
                    <mat-error>{{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get(zoneControlName(z.zone)) ?? null) }}</mat-error>
                    }
                  </mat-form-field>
                  }
                </div>
                } @else {
                <mat-form-field appearance="outline" class="col-md-12">
                  <mat-label>Delivery Charge</mat-label>
                  <input matInput formControlName="deliveryCharge" type="number"
                    [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                  @if (isRequestQuoteControl?.value) {
                    <mat-hint class="text-amber-600">Not Applicable</mat-hint>
                  }
                  @if (shouldShowError(countrySpecificForm.get(country.iso2)?.get('deliveryCharge') ?? null)) {
                  <mat-error>{{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get('deliveryCharge') ?? null) }}</mat-error>
                  }
                </mat-form-field>
                }
                }
                  </div>
                  <mat-checkbox formControlName="walkInOnly" class="mt-3 flex-shrink-0">
                    Walk in Only
                  </mat-checkbox>
                </div>

              </div>

              <div class="mt-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span class="text-sm font-medium">Product Variations</span>
                  <span class="text-muted" style="font-size: 0.75rem;">(At least one required)</span>
                </div>
                <div class="product-options">
                  <fh-product-options
                    [formControl]="getCountryControl(country.iso2, 'productOptions')"
                    [isRequestQuote]="isRequestQuoteControl?.value ?? false"
                    [sameCountry]="isSupplierCountry(country.iso2)"
                  ></fh-product-options>
                </div>
              </div>
            </div>
            }
          </mat-expansion-panel>
          }
        </div>
        }

  </mat-accordion>
</div>
